import React, { useContext, useEffect, useState } from "react";
import "rc-table/assets/index.css";
import Table from "rc-table";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination, Grid } from "swiper/modules";
import { Shimmer } from "react-shimmer";
import { object } from "yup";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Button, Badge } from "reactstrap";
import { FaShoppingCart } from "react-icons/fa"; // Using react-icons for the cart icon
import { useDispatch, useSelector } from "react-redux";
import { singleproduct } from "../api/Pageapi";
import HeadingBanner, { HeadingBannerCart } from "../Components/HeadingBanner";
import { FaTrash, FaTicketAlt } from "react-icons/fa";
import { decrement, setCount } from "../store/slices/counterSlice";
import { Logindetail } from "../context/Logindetail";
import { fetchApiArttoCartList } from "../store/actions/apiActions";
import { GetCartList_Fun, Removetocart_fun } from "../api/Scheme2";
import instance from "../Config/Config";
import toast from "react-hot-toast";
import { getSettingApi } from "../api/Controllapi";

const CartPage = ({ image, setting_data }) => {
  const [setting, setSetting] = useState(null);
  const [response, setresponse] = useState();
  const product_id = 13;
  const [IsLoading, setIsLoading] = useState(true);
  const [similar_data, setsimilar_data] = useState([]);
  const [imageid, setimageid] = useState();
  const { state } = useLocation();
  const { token, detail_info, setdetail_info } = useContext(Logindetail)
  const router = useNavigate();
  

  const dispatch = useDispatch();
  const count = useSelector((state) => state.counter.value);


  // const count = useSelector((state) => state.counter.userCounts?.[62] || 0);

  const handleAddRate = (record) => {
    // console.log("Add gold rate button clicked", "record:", record);
    if (count > 0) dispatch(decrement());
  };
  const [totapricedata, setTotalPriceData] = useState()
  const handlePayment = async () => {
    if (detail_info && token) {
      // console.log("User can Proceed to Buy");


      try {
        const responseApi = await instance.get("address");
        const addressList = responseApi?.data?.data || [];

        if (addressList.length > 0) {
          router("/checkout", {
            state: {
              total: totapricedata,
            },
          });
        } else {
          router("/FillForm", {
            state: {
              total: totapricedata,
              type: "user",
            },
          });
        }
      } catch (err) {
        console.error("Failed to fetch address:", err);
      }

    } else {
      // Trigger login popup if user is not authenticated
      document.getElementById("loginPopupopen")?.click();
    }
  };

  const API_URL =
    "http://192.168.1.114/green_heap_gold/public/api/v1/get_cart_list";

  const API_URL2 =
    "http://192.168.1.114/green_heap_gold/public/api/v1/remove_cart";

  const [cartData, setCartData] = useState([]);

  const GetCartListfirst = async () => {
    try {
      const responseApi = await instance.get(`get_cart_list`);
      const itemCount = responseApi?.data?.carts?.length || 0;
      dispatch(setCount(itemCount));
      const transformed = responseApi.data?.carts?.map((item) => ({
        key: item.id,
        component: item.product?.name || "Unknown",
        quantity: item.quantity || 0,
        gold_rate: parseFloat(item.product?.price || 0),
        price: parseFloat(item.price) || 0, // numeric value
        final_value: Number(item.price).toLocaleString('en-IN', {
          style: 'currency',
          currency: 'INR',
          minimumFractionDigits: 2,
        }),
        productId: item.product?.id,
        is_sold: item.product?.is_sold,
        product_quantity: item.product?.quantity,
        garms: item.garms,
        unit_id: item.product?.unit_id,
      }));

      // const transformed = responseApi.data?.carts?.map((item) => ({
      //   key: item.id,
      //   component: item.product?.name || "Unknown",
      //   quantity: item.quantity || 0,
      //   gold_rate: parseFloat(item.product?.price || 0),
      //   // weight: extractWeightFromName(item.product?.name),
      //   // final_value: parseFloat(item.price),
      //   final_value: Number(item.price).toLocaleString('en-IN', {
      //     style: 'currency',
      //     currency: 'INR',
      //     minimumFractionDigits: 2,
      //   }),
      //   productId: item.product?.id,
      // }));
      setIsLoading(false);
      // console.log("Cart data:", responseApi.data);
      setTotalPriceData(responseApi.data)
      setCartData(transformed || []);
      return transformed;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to update quantity";

      toast.error(message);
      setIsLoading(false);
      console.error(
        "Error fetching cart:",
        error.response?.data || error.message
      );

      return [];
    }
  };



  const GetCartList = async () => {
    GetCartList_Fun()
      .then((responseApi) => {
        const transformed = responseApi.data?.carts?.map((item) => ({
          key: item.id,
          component: item.product?.name || "Unknown",
          quantity: item.quantity || 0,
          gold_rate: parseFloat(item.product?.price || 0),
          price: parseFloat(item.price) || 0,
          // weight: extractWeightFromName(item.product?.name),
          // final_value: parseFloat(item.price),
          final_value: Number(item.price).toLocaleString('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 2,
          }),
          productId: item.product?.id,
          is_sold: item.product?.is_sold,
          garms: item.garms,
          unit_id: item.product?.unit_id,
        }));
        setIsLoading(false);
        // console.log("Cart data:", responseApi);

        setCartData(transformed || []);

        return transformed;
      })

      .catch((error) => {
        setIsLoading(true);
        console.error(
          "Error fetching cart:",
          error.response?.data || error.message
        );
      });
  };

  const navigate = useNavigate()

  const handleRemoveItem = async (id) => {
    setIsLoading(true);
    try {
      const url = `remove_cart?cart_id=${id}`;
      await instance.delete(url);
      dispatch(decrement());
      await GetCartListfirst();
    } catch (error) {
      setIsLoading(false);
      console.error(
        "Error removing item:",
        error.response?.data || error.message
      );
      toast.error("Failed to remove item");
    }
  };

  // Auth guard: redirect unauthenticated users to home with login popup
  useEffect(() => {
    if (!token) {
      navigate("/");
      setTimeout(() => {
        const trigger = document.getElementById("loginPopupopen");
        if (trigger) trigger.click();
      }, 100);
    }
  }, [token]);

  useEffect(() => {
    if (token && detail_info) {
      GetCartListfirst();
    }

    // Fetch settings dynamically using the base URL from .env
    const baseUrl = process.env.REACT_APP_BASE_URL || "https://admin.greenheapgold.com/public/api/v1/";
    axios.get(`${baseUrl}setting`)
      .then((res) => {
        setSetting(res.data);
      })
      .catch((err) => {
        console.error("Failed to fetch settings:", err);
      });
  }, [token, detail_info]);


  // const formatPrice = (price) => {
  //   // Strip any non-numeric characters except dot
  //   const numericPrice = parseFloat(price.toString().replace(/[^\d.]/g, '')) || 0;
  //   return numericPrice.toFixed(2); // format as 2 decimal places
  // };

  // const parsePrice = (priceString) => {
  //   // Remove all non-digit/non-dot characters
  //   const numeric = parseFloat(priceString.toString().replace(/[^\d.]/g, '')) || 0;
  //   return numeric;
  // };


  // const handleQuantityChange = async (id, newQuantity) => {
  //   if (newQuantity < 1) return;

  //   setCartData((prev) =>
  //     prev.map((item) =>
  //       item.key === id ? { ...item, quantity: newQuantity } : item
  //     )
  //   );

  //   try {
  //     await instance.post(`/update_to_cart`, {
  //       cart_id: id,
  //       quantity: newQuantity,
  //     });
  //     // Optionally refresh cart count or other data
  //   } catch (error) {
  //     console.error("Failed to update quantity:", error.response?.data || error.message);
  //   }
  // };
  const handleQuantityChange = async (id, newQuantity, price) => {
    if (newQuantity < 1) return;


    const numericPrice = Number(
      typeof price === "number"
        ? price
        : parseFloat(price?.toString().replace(/[^\d.]/g, ""))
    ) || 0;

    const total = numericPrice * newQuantity;
    // console.log("Total for item:", id, "=", total);


    setCartData((prev) =>
      prev.map((item) =>
        item.key === id ? { ...item, quantity: newQuantity } : item
      )
    );

    try {
      await instance.post(`/update_to_cart`, {
        cart_id: id,
        quantity: newQuantity,
      });


      GetCartListfirst();
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to update quantity";

      toast.error(message);
      console.error(
        "Failed to update quantity:",
        error.response?.data || error.message
      );


      setCartData((prev) =>
        prev.map((item) =>
          item.key === id
            ? { ...item, quantity: newQuantity === 1 ? 2 : newQuantity - 1 }
            : item
        )
      );
    }
  };




  // const handleQuantityChange = async (id, newQuantity, price) => {
  //   const numericPrice = parseFloat(price.replace(/[^\d.]/g, '')); // removes everything except digits and dot
  //   const total = numericPrice * newQuantity;
  //   console.log(total, "fgs");

  //   if (newQuantity < 1) return;

  //   setCartData((prev) =>
  //     prev.map((item) =>
  //       item.key === id ? { ...item, quantity: newQuantity } : item
  //     )
  //   );

  //   try {
  //     await instance.post(`/update_to_cart`, {
  //       cart_id: id,
  //       quantity: newQuantity,
  //       // price: price,
  //     });

  //     // console.log(`Quantity updated to ${newQuantity} for item ${id}`);
  //     GetCartListfirst()
  //   } catch (error) {
  //     console.error(
  //       "Failed to update quantity:",
  //       error.response?.data || error.message
  //     );

  //     // Optional: Rollback UI change if API fails
  //     setCartData((prev) =>
  //       prev.map((item) =>
  //         item.key === id
  //           ? { ...item, quantity: newQuantity === 1 ? 2 : newQuantity - 1 }
  //           : item
  //       )
  //     );
  //   }

  //   // try {
  //   //   await axios.post(
  //   //    `http://192.168.1.114/green_heap_gold/public/api/v1/update_to_cart`,
  //   //     {
  //   //       cart_id:id,
  //   //       quantity: newQuantity,
  //   //       price: price,
  //   //     },
  //   //     {
  //   //        headers: {
  //   //         'Authorization': 'Bearer 1509|nKdmcF8XTx7lAilP7Aco73AHFukFqSYnlMceNBBlfc3ea33d',
  //   //         'Content-Type': 'application/json'
  //   //       },
  //   //     }
  //   //   );

  //   //   console.log(`Quantity updated to ${newQuantity} for item ${id}`);
  //   // } catch (error) {
  //   //   console.error('Failed to update quantity:', error.response?.data || error.message);

  //   //   // Optional: Rollback UI change if API fails
  //   //   setCartData(prev =>
  //   //     prev.map(item =>
  //   //       item.key === id ? { ...item, quantity: newQuantity === 1 ? 2 : newQuantity - 1 } : item
  //   //     )
  //   //   );
  //   // }
  // };

  //   const columns = [
  //     {
  //       title: "Product",
  //       dataIndex: "component",
  //       key: "component",
  //       render: (_, record) => (
  //         <span
  //           style={{ cursor: "pointer", textDecoration: "none" }}
  //           onClick={() => router(`/detail/${record.productId}`)}
  //         >
  //           {record.component}
  //         </span>
  //       ),
  //     },

  //     {
  //       title: "Quantity",
  //       key: "quantity",
  //       render: (_, record) => (
  //         <div className="d-flex align-items-center justify-content-center gap-2">
  //           <button
  //             className="btn btn-sm btn-outline-secondary"
  //             onClick={() =>
  //               handleQuantityChange(
  //                 record.key,
  //                 record.quantity - 1,
  //                 record.final_value
  //               )
  //             }
  //             disabled={record.quantity <= 1}
  //           >
  //             -
  //           </button>
  //           <span style={{ minWidth: 20, textAlign: "center" }}>
  //             {record.quantity}
  //           </span>
  //           <button
  //             className="btn btn-sm btn-outline-secondary"
  //             onClick={() =>
  //               handleQuantityChange(
  //                 record.key,
  //                 record.quantity + 1,
  //                 record.final_value
  //               )
  //             }
  //           >
  //             +
  //           </button>
  //         </div>
  //       ),
  //     },

  //     // {
  //     //   title: "Price",
  //     //   dataIndex: "final_value",
  //     //   key: "final_value",
  //     // },
  //     {
  //   title: "Price",
  //   key: "total_price",
  //   render: (_, record) => {
  //     const numericPrice = parseFloat(record.final_value?.toString().replace(/[^\d.]/g, "")) || 0;
  //     const totalPrice = numericPrice * record.quantity;
  //     return <span>{totalPrice.toFixed(2)}</span>;
  //   },
  // },

  // //   {
  // //   title: "Price",
  // //   key: "total_price",
  // //   render: (_, record) => {
  // //     const totalPrice = record.price * record.quantity;
  // //     console.log(totalPrice, "ddg");
  // //     return (
  // //       <span>
  // //         {totalPrice.toFixed(2)}
  // //       </span>
  // //     );
  // //   },
  // // },



  //     {
  //       title: "Remove",
  //       key: "remove",
  //       render: (_, record) => (
  //         <button
  //           onClick={() => handleRemoveItem(record.key)}
  //           className="btn btn-link text-danger p-0"
  //           title="Remove"
  //         >
  //           <FaTrash color="#8a3022" />
  //         </button>
  //       ),
  //     },
  //   ];


  const columns = [
    {
      title: "Product",
      dataIndex: "component",
      key: "component",
      render: (_, record) => (
        <span
          style={{
            cursor: record.is_sold === 1 ? "not-allowed" : "pointer",
            // textDecoration: record.is_sold === 1 ? "line-through" : "none",
            // color: record.is_sold === 1 ? "gray" : "inherit",
          }}
          onClick={() => {
            if (record.is_sold !== 1) {
              router(`/detail/${record.productId}`);
            }
          }}
        >
          <>
            <div className="fw-bold">
              {record?.component}
              {record?.is_sold === 1 && (
                <span className="text-danger small ms-1">(Sold)</span>
              )}
            </div>
            {record?.garms?.slot_label && (
              <div className="text-danger small">
                Weight: {record.garms.slot_label}g
              </div>
            )}
          </>

        </span>
      ),
    },
    // {
    //   title: "Quantity",
    //   key: "quantity",
    //   render: (_, record) =>
    //     record.is_sold === 1 ? (
    //       <span>Sold</span>
    //     ) : (
    //       <div className="d-flex align-items-center justify-content-center gap-2">
    //         <button
    //           className="btn btn-sm btn-outline-secondary"
    //           onClick={() =>
    //             handleQuantityChange(
    //               record.key,
    //               record.quantity - 1,
    //               record.final_value
    //             )
    //           }
    //           disabled={record.quantity <= 1}
    //         >
    //           -
    //         </button>
    //         <span style={{ minWidth: 20, textAlign: "center" }}>
    //           {record.quantity}
    //         </span>
    //         <button
    //           className="btn btn-sm btn-outline-secondary"
    //           onClick={() =>
    //             handleQuantityChange(
    //               record.key,
    //               record.quantity + 1,
    //               record.final_value
    //             )
    //           }
    //         >
    //           +
    //         </button>
    //       </div>
    //     ),
    // },
    {
      title: "Quantity",
      key: "quantity",
      render: (_, record) => (
        record.unit_id === 6 ? (
          <div className="d-flex align-items-center justify-content-center gap-2">
            <span style={{ minWidth: 20, textAlign: "center" }}>
              {record.quantity}
            </span>
          </div>
        ) : (
          <div className="d-flex align-items-center justify-content-center gap-2">
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={() =>
                handleQuantityChange(
                  record.key,
                  record.quantity - 1,
                  record.final_value
                )
              }
              disabled={record.quantity <= 1}
            >
              -
            </button>
            <span style={{ minWidth: 20, textAlign: "center" }}>
              {record.quantity}
            </span>
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={() =>
                handleQuantityChange(
                  record.key,
                  record.quantity + 1,
                  record.final_value
                )
              }
            >
              +
            </button>
          </div>
        )
      ),
    },
    
    {
      title: "Price",
      key: "total_price",
      render: (_, record) => {
        const totalPrice = record.price * record.quantity;
        // console.log(totalPrice, "ddg");
        return (
          <span>
            {totalPrice.toFixed(2)}
          </span>
        );
      },
    },



    {
      title: "Remove",
      key: "remove",
      render: (_, record) => (
        <button
          onClick={() => handleRemoveItem(record.key)}
          className="btn btn-link text-danger p-0"
          title="Remove"
        >
          <FaTrash color="#8a3022" />
        </button>
      ),
    },
  ];


  const [isHovered, setIsHovered] = useState(false);
  const isAnySold = cartData?.some((item) => Number(item.is_sold) === 1);

  const getImageUrl = (imagePath) => {
    if (!imagePath) return "/assets/images/green1.png";
    if (String(imagePath).startsWith("http")) return imagePath;

    const base_url_env = process.env.REACT_APP_BASE_URL || "";
    const baseUrl = base_url_env.replace("/api/v1/", "/");
    return `${baseUrl}${imagePath}`;
  };

  const discountData = setting_data?.data?.[0] || setting?.data?.[0];
  
  // const silverTotal = totapricedata?.progress_bar_amount || 0;
  const silverTotal = Math.round(totapricedata?.progress_bar_amount || 0);
  const targetAmount = Number(discountData?.discount_amount || 0);


    const progressPercentage =
  targetAmount > 0
    ? Math.floor(Math.min((silverTotal / targetAmount) * 100, 100))
    : 0;
  const remainingAmount = Math.max(targetAmount - silverTotal, 0);
  const isUnlocked = remainingAmount <= 0;


  return (
    <div>
      <HeadingBannerCart image={image} />

      <section className="price-break pb-5 pt-lg-3">
        <div className="container-xl mb-5">
          <div className="row">
            {/* Main Cart Items Section */}
            <div className="col-xl-9 col-lg-9 col-md-12 col-sm-12">
              {IsLoading ? (
                <div className="siptable-view">
                  <table className="table border rounded">
                    <thead>
                      <tr className="pd-tableload">
                        <th scope="col" className="h5">Component</th>
                        <th scope="col" className="h5">Gold Rate(18KT)</th>
                        <th scope="col" className="h5">Weight</th>
                        <th scope="col" className="h5">Discount</th>
                        <th scope="col" className="h5">Final Value</th>
                      </tr>
                    </thead>
                    <tbody className="border rounded">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <tr className="text-center" key={i}>
                          <td className="text-center"><Shimmer height={15} width={100} className="rounded ms-2" /></td>
                          <td className="text-center"><Shimmer height={15} width={100} className="rounded" /></td>
                          <td className="text-center"><Shimmer height={15} width={100} className="rounded" /></td>
                          <td className="text-center"><Shimmer height={15} width={150} className="rounded" /></td>
                          <td className="text-center"><Shimmer height={15} width={150} className="rounded" /></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : cartData?.length > 0 ? (
                <Table
                  scroll={{ x: 650 }}
                  columns={columns}
                  data={cartData}
                  aria-labelledby="lblPeopleTable"
                />
              ) : (
                <div className="custom-scroll-hidden-table">
                  <Table
                    scroll={{ x: 650 }}
                    columns={columns}
                    dataSource={cartData}
                    aria-labelledby="lblPeopleTable"
                  />
                </div>
              )}
            </div>

            {/* Price Details Sidebar */}
            {IsLoading ? (
              <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12">
                <div
                  style={{
                    padding: "20px",
                    backgroundColor: "#fbf9fa",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    borderRadius: "8px",
                  }}
                >
                  <Shimmer height={30} width={150} className="mb-3 rounded" />
                  <hr />
                  {Array.from({ length: 3 }).map((_, i) => (
                    <div key={i} className="d-flex justify-content-between mb-2">
                      <Shimmer height={15} width={120} className="rounded" />
                      <Shimmer height={15} width={70} className="rounded" />
                    </div>
                  ))}
                  <hr />
                  <div className="d-flex justify-content-between mb-3 pt-2">
                    <Shimmer height={20} width={90} className="rounded" />
                    <Shimmer height={20} width={90} className="rounded" />
                  </div>
                  <div style={{ width: "100%" }}><Shimmer height={50} width={300} className="rounded mt-3 w-100" /></div>
                </div>
              </div>
            ) : totapricedata?.carts?.length > 0 ? (
              <div
                className="col-xl-3 col-lg-3 col-md-12 col-sm-12"
                style={{
                  padding: "20px",
                  backgroundColor: "#fbf9fa",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  borderRadius: "8px",
                  height: "max-content",
                }}
              >
                <h4 style={{ color: "#972734", fontWeight: "bold" }} className="mb-3">
                  Cart Total
                </h4>
                <hr />

                <div className="cart-items-summary mb-3">
                  {cartData?.map((item, index) => (
                    <div key={index} className="d-flex justify-content-between align-items-start mb-2">
                      <div className="mb-0 text-muted" style={{ fontSize: "14px" }}>
                        <div className="text-dark">
                          {item.component?.length > 20 ? item.component.substring(0, 20) + '...' : item.component} 
                          {item.is_sold === 1 && <span className="text-danger small ms-1" style={{ fontSize: "10px" }}>(Sold)</span>}
                          <span className="fw-bold ms-1">x {item.quantity}</span>
                        </div>
                        {item.garms?.slot_label && (
                          <div className="small text-muted" style={{ fontSize: "11px" }}>
                            Weight: {item.garms.slot_label}g
                          </div>
                        )}
                      </div>
                      <p className="mb-0 fw-bold" style={{ fontSize: "14px" }}>
                        ₹{(item.price * item.quantity).toLocaleString('en-IN', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </p>
                    </div>
                  ))}
                </div>
                <hr />

                {totapricedata?.special_discount > 0 && (
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <p className="mb-0"><b>Special Discount</b></p>
                    <p className="mb-0 text-success">
                      <b>- ₹{Number(totapricedata?.special_discount || 0).toLocaleString('en-IN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}</b>
                    </p>
                  </div>
                )}

                <div className="d-flex justify-content-between align-items-center mb-2">
                  <p className="mb-0"><b>Total Price</b></p>
                  <p className="mb-0">
                    <b>₹{Number(totapricedata?.total || 0).toLocaleString('en-IN', {
                      maximumFractionDigits: 0,
                    })}</b>
                  </p>
                </div>

                {/* {discountData && (
                  <div className="discount-banner p-3 rounded mt-3 text-white" style={{
                    background: "linear-gradient(135deg, #ff9a44 0%, #fc6076 100%)",
                    boxShadow: "0 4px 15px rgba(252, 96, 118, 0.3)",
                    position: "relative",
                    overflow: "hidden"
                  }}>
                 
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <div className="d-flex gap-2">
                        <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: "30px", height: "30px", backgroundColor: "#ff5722" }}>
                          <img src="/assets/iocns/offer.png" alt="offer" style={{ width: "20px", filter: "brightness(0) invert(1)" }} />
                        </div>
                        <div>
                          <div className="d-flex align-items-center gap-2">
                            <span className="fw-bold" style={{ fontSize: "14px" }}>Discount Coupon</span>
                            <span className="badge bg-white text-danger rounded-pill px-2 py-1" style={{ fontSize: "10px" }}>{discountData?.discount_percentage}% OFF</span>
                          </div>
                          <div style={{ fontSize: "11px", opacity: 0.9 }}>Unlock your savings</div>
                          <div style={{ fontSize: "10px", opacity: 0.8 }}>Spend ₹{Number(targetAmount).toLocaleString('en-IN')} & save ₹{Number(targetAmount * discountData?.discount_percentage / 100).toLocaleString('en-IN')}</div>
                        </div>
                      </div>
                      <img src="/assets/iocns/__Fav Icon.png" alt="logo" style={{ width: "30px" }} />
                    </div>

                    <hr style={{ margin: "10px 0", opacity: 0.3, borderTop: "1px dashed white" }} />

                   
                    <div className="mb-2">
                      <div className="d-flex justify-content-between mb-1" style={{ fontSize: "11px" }}>
                        <span>Current: ₹{Number(silverTotal).toLocaleString('en-IN', { maximumFractionDigits: 0 })}</span>
                        <span>{progressPercentage.toFixed(0)}%</span>
                      </div>
                      <div className="progress" style={{ height: "6px", backgroundColor: "rgba(255,255,255,0.3)", borderRadius: "3px" }}>
                        <div className="progress-bar bg-white" style={{ width: `${progressPercentage}%`, borderRadius: "3px" }}></div>
                      </div>
                    </div>

                    
                    <div className="bg-white bg-opacity-25 rounded p-2 d-flex align-items-center gap-2 mb-2" style={{ fontSize: "11px", backgroundColor: "rgba(255,255,255,0.15)" }}>
                      <FaShoppingCart size={14} />
                      {remainingAmount > 0 ? (
                        <span>Add ₹{Number(remainingAmount).toLocaleString('en-IN', { maximumFractionDigits: 0 })} more for {discountData?.discount_percentage}% off</span>
                      ) : (
                        <span>You've unlocked the {discountData?.discount_percentage}% discount!</span>
                      )}
                    </div>

                    <div className="text-center" style={{ fontSize: "9px", opacity: 0.9, fontStyle: "italic" }}>
                      This offer is applicable only for Silver Jewelry, not for Gold.
                    </div>
                  </div>
                )} */}
{discountData && (
  <div
    className="discount-banner p-3 rounded mt-3 mb-4 text-white"
    style={{
      background: isUnlocked
        ? "linear-gradient(135deg, #2e7d32 0%, #66bb6a 100%)" // GREEN (success)
        : "linear-gradient(135deg, #ff9a44 0%, #fc6076 100%)", // ORANGE (progress)
      boxShadow: isUnlocked
        ? "0 4px 15px rgba(76, 175, 80, 0.3)"
        : "0 4px 15px rgba(252, 96, 118, 0.3)",
      position: "relative",
      overflow: "hidden",
    }}
  >
    {/* TOP */}
    <div className="d-flex justify-content-between align-items-start mb-2">
      <div className="d-flex gap-2">
        <div
          className="rounded-circle d-flex align-items-center justify-content-center"
          style={{
            width: "30px",
            height: "30px",
            backgroundColor: isUnlocked ? "#1b5e20" : "#ff5722",
          }}
        >
          <img
            src="/assets/iocns/offer.png"
            alt="offer"
            style={{ width: "20px", filter: "brightness(0) invert(1)" }}
          />
        </div>

        <div>
          <div className="d-flex align-items-center gap-2">
            <span className="fw-bold" style={{ fontSize: "14px" }}>
              {isUnlocked ? "Discount Coupon Applied" : "Discount Coupon"}
            </span>

            <span className="badge bg-white text-danger rounded-pill px-2 py-1" style={{ fontSize: "10px" }}>
              {discountData?.discount_percentage}% OFF
            </span>
          </div>

          <div style={{ fontSize: "11px", opacity: 0.9 }}>
            {/* {isUnlocked
              ? `You saved ₹${Number(
                  silverTotal * discountData?.discount_percentage / 100
                ).toLocaleString("en-IN")}`
              : "Unlock your savings"} */}
              {isUnlocked
  ? `You saved ₹${Math.round(
      (Number(silverTotal) * (discountData?.discount_percentage || 0)) / 100
    ).toLocaleString("en-IN")}`
  : "Unlock your savings"}

                        {!isUnlocked && (
              <div style={{ fontSize: "10px", opacity: 0.8 }}>
                Spend ₹{Number(targetAmount).toLocaleString('en-IN')} & save ₹
                {Number(targetAmount * (discountData?.discount_percentage || 0) / 100).toLocaleString('en-IN')}
              </div>
            )}       
          </div>
          
        </div>
      </div>

      <img src="/assets/iocns/__Fav Icon.png" alt="logo" style={{ width: "30px" }} />
    </div>

    <hr style={{ margin: "10px 0", opacity: 0.3, borderTop: "1px dashed white" }} />

    {/* PROGRESS (only if NOT unlocked) */}
    {/* {!isUnlocked && (
      <div className="mb-2">
        <div className="d-flex justify-content-between mb-1" style={{ fontSize: "11px" }}>
          <span>₹{Number(silverTotal).toLocaleString("en-IN")}</span>
          <span>{progressPercentage.toFixed(0)}%</span>
        </div>

        <div className="progress" style={{ height: "6px", backgroundColor: "rgba(255,255,255,0.3)" }}>
          <div className="progress-bar bg-white" style={{ width: `${progressPercentage}%` }} />
        </div>
      </div>
    )} */}
    {!isUnlocked && (
  <div className="mb-2">
    
    {/* Progress bar FIRST */}
    <div
      className="progress mb-1"
      style={{ height: "6px", backgroundColor: "rgba(255,255,255,0.3)" }}
    >
      <div
        className="progress-bar bg-white"
        style={{ width: `${progressPercentage}%` }}
      />
    </div>

    {/* Amount row BELOW */}
    <div
      className="d-flex justify-content-between"
      style={{ fontSize: "11px" }}
    >
      <span>Current: ₹{Number(silverTotal).toLocaleString("en-IN")}</span>
      <span>{Math.round(progressPercentage)}%</span>
    </div>

  </div>
)}

    {/* MESSAGE */}
    <div
      className="bg-white bg-opacity-25 rounded p-2 d-flex align-items-center gap-2 mb-2"
      style={{ fontSize: "11px" }}
    >
      <FaShoppingCart size={14} />

      {isUnlocked ? (
        <span>Maximum discount applied to your cart</span>
      ) : (
        <span>
          Add ₹{Number(remainingAmount).toLocaleString("en-IN")} more for{" "}
          {discountData?.discount_percentage}% off
        </span>
      )}
    </div>

    {/* FOOTER */}
    <div className="text-center" style={{ fontSize: "9px", opacity: 0.9 }}>
      
      This offer is applicable only for Silver Jewelry not for Silver coins and Gold.
    </div>
  </div>
)}

                {totapricedata?.grand_total > 0 && (
                  <div
                    style={{
                      backgroundColor: isAnySold ? "#ccc" : isHovered ? "#99131e" : "#f8eeed",
                      padding: "1px",
                      color: isAnySold ? "#666" : isHovered ? "#ffffff" : "#650020",
                      cursor: isAnySold ? "not-allowed" : "pointer",
                      borderRadius: "5px",
                      textAlign: "center",
                      transition: "all 0.3s ease",
                    }}
                    onClick={async () => {
                      const updatedCart = await GetCartListfirst();
                      const hasSoldItems = updatedCart.some(item => item.is_sold === 1 || item.is_sold === true);
                      const invalidItem = updatedCart?.find((item) => {
                        const cartQty = Number(item?.quantity ?? 0);
                        const stockQty = Number(item?.product_quantity ?? 0);
                        return cartQty > stockQty;
                      });

                      if (invalidItem) {
                        toast.error(`${invalidItem?.component ?? 'This item'} has insufficient stock (${Number(invalidItem?.product_quantity ?? 0)} Available)`);
                        return;
                      }
                      if (hasSoldItems) {
                        toast.error("Some items are sold out. Please remove them from your cart to proceed.");
                        return;
                      }
                      handlePayment();
                    }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                  >
                    <p className="mt-3"><b>Proceed to Buy</b></p>
                  </div>
                )}
              </div>
            ) : (
              <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12 d-flex align-items-center justify-content-center">
                <div className="text-center p-4">
                  <img src="/assets/noData.png" alt="No Data" width={160} />
                  <p className="mt-2 text-muted">Your cart is empty</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default CartPage;
